import { render } from "./videoMessage.vue?vue&type=template&id=5fdc86c2&scoped=true"
import script from "./videoMessage.vue?vue&type=script&lang=js"
export * from "./videoMessage.vue?vue&type=script&lang=js"

import "./videoMessage.vue?vue&type=style&index=0&id=5fdc86c2&lang=scss&scoped=true"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdc86c2"]])

export default __exports__